var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5156,
    cy: 25.5156,
    r: 25.5156,
    transform: "matrix(-1 0 0 1 51.0312 -0.0078125)",
    fill: "url(#paint0_linear_4511_7517)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4511_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4819 25.4215L22.1388 35.2489C21.6411 35.6792 20.8347 35.6792 20.3357 35.2489C19.838 34.8186 19.838 34.1197 20.3357 33.6895L30.7791 24.6418L20.337 15.5942C19.8393 15.1639 19.8393 14.465 20.337 14.0336C20.8347 13.6034 21.6424 13.6034 22.1401 14.0336L33.4832 23.861C33.9733 24.2868 33.9733 24.9966 33.4819 25.4215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4511_7517",
    x: 5.66797,
    y: 5.65625,
    width: 42.5264,
    height: 48.1997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3403
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.67014
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4511_7517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4511_7517",
    x1: 0.0130257,
    y1: 25.5179,
    x2: 51.0364,
    y2: 25.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3656BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001D78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.780278cf42a7c2aad9d25900d10a2884.svg";
export { ForwardRef as ReactComponent };